import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class AnnouncementService {

  constructor(private httpClient: HttpClient, private apiService: ApiService) {}

  public forPlacement(placement: string): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/public/${this.apiService.organizationId()}/announcements/${placement}`);
  }
}
